interface CounterOptions {
  onIncrement?: (count: number) => void
  onDecrement?: (count: number) => void
}

export function counter(options: CounterOptions): [() => void, () => void] {
  const { onIncrement = () => {}, onDecrement = () => {} } = options

  let count = 0

  function increment() {
    count++
    onIncrement(count)
  }

  function decrement() {
    count--
    onDecrement(count)
  }

  return [increment, decrement]
}
